import { twMerge } from 'tailwind-merge';

type ProgressBarProps = {
  current: number;
  total: number;
  minRatio?: number;
};

export function ProgressBar(props: ProgressBarProps) {
  const currentParsed = props.current ?? 0;
  const totalParsed =
    (props.total == null || props.total < currentParsed ? currentParsed : props.total) ?? 0;

  let statusBarColor = 'bg-branding-accent';
  let statusRatio = Math.round((currentParsed * 100) / totalParsed);
  const minRatio = props.minRatio ?? 0;

  // NOTE: this is a special case where the user doesn't have any  and on these
  //       cases we can't really calculate ratio, so, we make sure that the ratio is
  //       always 1
  if (Number.isNaN(statusRatio) || totalParsed === 0) {
    statusRatio = 100;
  } else if (statusRatio < minRatio) {
    statusRatio = minRatio;
  }

  // reached the end
  if (currentParsed >= totalParsed) {
    statusBarColor = 'bg-red-600';
  } else if (statusRatio > 90) {
    statusBarColor = 'bg-orange-400';
  }

  return (
    <div className="relative mt-2 h-1 overflow-hidden rounded-full bg-branding-accent-200">
      <div
        className={twMerge('absolute left-0 top-0 h-full rounded-md', statusBarColor)}
        style={{ width: `${statusRatio}%` }}
      ></div>
    </div>
  );
}
